import { render, staticRenderFns } from "./TrailPropertyStatistic.vue?vue&type=template&id=27d459bf"
import script from "./TrailPropertyStatistic.vue?vue&type=script&lang=js"
export * from "./TrailPropertyStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports